(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-desplegable-grillcorp"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gc-faq-carousel')) {
    customElements.define('gc-faq-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;
        this.viewport = this.querySelector('[data-gc-faq-track]');
        this.slides = Array.from(this.querySelectorAll('[data-gc-faq-slide]'));
        this.prevButton = this.querySelector('[data-gc-faq-prev]');
        this.nextButton = this.querySelector('[data-gc-faq-next]');
        this.dots = Array.from(this.querySelectorAll('[data-gc-faq-dot]'));
        if (!this.viewport || this.slides.length < 2) return;

        this._onScroll = () => {
          if (this._frame) return;
          this._frame = requestAnimationFrame(() => {
            this._frame = null;
            this.updateState();
          });
        };
        this._onToggle = () => {
          if (this.details && this.details.open) requestAnimationFrame(() => this.updateState());
        };
        this._onKeys = (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.currentIndex() + 1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.currentIndex() - 1);
          }
        };

        this._onPrevClick = () => this.goTo(this.currentIndex() - 1);
        this._onNextClick = () => this.goTo(this.currentIndex() + 1);
        this._onDotClicks = this.dots.map((dot) => () => this.goTo(Number(dot.dataset.gcFaqDot)));
        this.prevButton?.addEventListener('click', this._onPrevClick);
        this.nextButton?.addEventListener('click', this._onNextClick);
        this.dots.forEach((dot, index) => dot.addEventListener('click', this._onDotClicks[index]));
        this.viewport.addEventListener('scroll', this._onScroll, { passive: true });
        this.viewport.addEventListener('keydown', this._onKeys);
        this.details = this.closest('details');
        this.details?.addEventListener('toggle', this._onToggle);
        if ('ResizeObserver' in window) {
          this._observer = new ResizeObserver(() => this.updateState());
          this._observer.observe(this.viewport);
        }
        this.updateState();
      }

      disconnectedCallback() {
        if (this._frame) cancelAnimationFrame(this._frame);
        this._frame = null;
        this._observer?.disconnect();
        this.details?.removeEventListener('toggle', this._onToggle);
        this.viewport?.removeEventListener('scroll', this._onScroll);
        this.viewport?.removeEventListener('keydown', this._onKeys);
        this.prevButton?.removeEventListener('click', this._onPrevClick);
        this.nextButton?.removeEventListener('click', this._onNextClick);
        this.dots?.forEach((dot, index) => dot.removeEventListener('click', this._onDotClicks?.[index]));
        this._initialized = false;
      }

      currentIndex() {
        if (!this.viewport || this.slides.length < 2) return 0;
        const width = this.viewport.clientWidth;
        if (width < 1) return 0;
        return Math.min(this.slides.length - 1, Math.max(0, Math.round(this.viewport.scrollLeft / width)));
      }

      goTo(index) {
        if (!this.viewport || this.slides.length < 2) return;
        const target = Math.min(this.slides.length - 1, Math.max(0, index));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.viewport.scrollTo({
          left: target * this.viewport.clientWidth,
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      }

      updateState() {
        if (!this.viewport || this.slides.length < 2) return;
        const active = this.currentIndex();
        if (this.prevButton) this.prevButton.disabled = active === 0;
        if (this.nextButton) this.nextButton.disabled = active === this.slides.length - 1;
        this.dots.forEach((dot, index) => {
          dot.setAttribute('aria-current', index === active ? 'true' : 'false');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-catalogo-filtrable"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function initCatalog(root) {
    if (!root || root.dataset.gcReady === '1') return;
    root.dataset.gcReady = '1';

    var initialCount = parseInt(root.dataset.gcInitialCount, 10) || 8;
    var increment = parseInt(root.dataset.gcLoadIncrement, 10) || 8;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-gc-card]'));
    var filters = { collection: 'all', finish: 'all', brand: 'all' };
    var visibleLimit = initialCount;

    var resultEl = root.querySelector('[data-gc-results]');
    var emptyEl = root.querySelector('[data-gc-empty]');
    var loadEl = root.querySelector('[data-gc-load]');
    var resetEls = Array.prototype.slice.call(root.querySelectorAll('[data-gc-reset]'));
    var brandHolder = root.querySelector('[data-gc-options="brand"]');

    if (brandHolder) {
      var brands = [];
      cards.forEach(function(card) {
        var key = card.dataset.gcBrand || '';
        var label = card.dataset.gcBrandLabel || '';
        if (key && !brands.some(function(b) { return b.key === key; })) {
          brands.push({ key: key, label: label });
        }
      });
      brands.sort(function(a, b) { return a.label.localeCompare(b.label, 'es'); });
      brands.forEach(function(brand) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'gc-catalogo__pill';
        button.dataset.gcFilter = 'brand';
        button.dataset.gcValue = brand.key;
        button.setAttribute('aria-pressed', 'false');
        button.textContent = brand.label;
        brandHolder.appendChild(button);
      });
    }

    function getVariant(card, finish) {
      if (finish !== 'precurado' && finish !== 'esmaltado') return null;
      var variants = Array.prototype.slice.call(card.querySelectorAll('[data-gc-variant]'));
      var pattern = finish === 'precurado'
        ? /pre[\s-]?curad|seasoned/i
        : /esmaltad|enameled|enamel/i;

      var matched = variants.filter(function(variant) {
        return pattern.test(variant.dataset.gcName || '');
      });
      if (matched.length === 0) return null;
      return matched.find(function(variant) {
        return variant.dataset.gcAvailable === 'true';
      }) || matched[0];
    }

    function applyProductVariant(card) {
      var variant = getVariant(card, filters.finish);
      var url = variant ? variant.dataset.gcUrl : card.dataset.gcDefaultHref;
      var price = variant ? variant.dataset.gcPrice : card.dataset.gcDefaultPrice;
      var photo = variant && variant.dataset.gcImage
        ? variant.dataset.gcImage
        : card.dataset.gcDefaultImage;

      card.querySelectorAll('[data-gc-link]').forEach(function(link) {
        if (url) link.setAttribute('href', url);
      });
      var priceEl = card.querySelector('[data-gc-price]');
      if (priceEl && price) priceEl.textContent = price;
      var imageEl = card.querySelector('.gc-catalogo__image');
      if (imageEl && photo && imageEl.getAttribute('src') !== photo) {
        imageEl.removeAttribute('srcset');
        imageEl.removeAttribute('sizes');
        imageEl.src = photo;
      }
    }

    function matches(card) {
      if (filters.collection !== 'all' &&
          (card.dataset.gcCollections || '').indexOf('|' + filters.collection + '|') === -1) {
        return false;
      }
      if (filters.finish !== 'all' &&
          (card.dataset.gcFinish || '').indexOf('|' + filters.finish + '|') === -1) {
        return false;
      }
      if (filters.brand !== 'all' && card.dataset.gcBrand !== filters.brand) return false;
      return true;
    }

    function render() {
      var candidates = cards.filter(matches);

      cards.forEach(function(card) {
        var position = candidates.indexOf(card);
        var show = position >= 0 && position < visibleLimit;
        card.hidden = !show;
        if (show) applyProductVariant(card);
      });

      if (resultEl) {
        var visible = Math.min(candidates.length, visibleLimit);
        resultEl.textContent = candidates.length + ' productos de la selección · mostrando ' + visible;
      }
      if (emptyEl) emptyEl.hidden = candidates.length !== 0;
      if (loadEl) loadEl.hidden = candidates.length <= visibleLimit;

      var hasFilters = Object.keys(filters).some(function(key) {
        return filters[key] !== 'all';
      });
      resetEls.forEach(function(button) {
        if (button.classList.contains('gc-catalogo__reset')) button.hidden = !hasFilters;
      });
      root.querySelectorAll('[data-gc-filter]').forEach(function(button) {
        var active = filters[button.dataset.gcFilter] === button.dataset.gcValue;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }

    root.addEventListener('click', function(event) {
      var filterButton = event.target.closest('[data-gc-filter]');
      if (filterButton && root.contains(filterButton)) {
        filters[filterButton.dataset.gcFilter] = filterButton.dataset.gcValue;
        visibleLimit = initialCount;
        render();
        return;
      }
      var resetButton = event.target.closest('[data-gc-reset]');
      if (resetButton && root.contains(resetButton)) {
        filters = { collection: 'all', finish: 'all', brand: 'all' };
        visibleLimit = initialCount;
        render();
        return;
      }
      var loadButton = event.target.closest('[data-gc-load]');
      if (loadButton && root.contains(loadButton)) {
        visibleLimit += increment;
        render();
      }
    });

    render();
  }

  function initializeAll(container) {
    if (container.matches && container.matches('[data-gc-catalogo]')) initCatalog(container);
    container.querySelectorAll('[data-gc-catalogo]').forEach(initCatalog);
  }

  function boot() { initializeAll(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Shopify Theme Editor: support section re-rendering without a page refresh.
  document.addEventListener('shopify:section:load', function(event) {
    initializeAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }
  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    // this.searchModal.close(false);
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
